import React, { useLayoutEffect, useState, useEffect, useRef } from "react";
import { Wrapper } from "./Users.styled";
import { useHistory, useLocation } from "react-router";
import UsersTable from "components/pageSection/Users/UsersTable";
import { Input, Row, Col, Button, Modal, Form, Loading, SuccessNotification, ErrorNotification, Drawer, Empty, Switch } from "components/common";
import Search from "assets/images/search.png";
import AddCustomer from "assets/images/add-customer.png";
import UserCard from "components/pageSection/Users/UserCard";
import AddNewUser from "./AddNewUser";
import { callDeleteApi, callGetApi, callPostApi } from "utils/api";
import { useDebounce } from "use-debounce";
import { saveStorage } from "utils/auth";
import { getUserPermissions } from "utils/text";
import { CheckOutlined } from "@ant-design/icons";
import addCustomer from "assets/images/add-customer.png";
import { FaUserPlus, FaSearch } from "react-icons/fa";


const UserCustomStyles = {
  searchRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  emptyStyle: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 20,
  }
}

const Users = () => {
  const ref = useRef();
  const userRef = useRef();
  const history = useHistory();
  const initialValues = { email: "", available: true, username: "", calId: "", hasCalId: false, locationId: "", roleId: "", active: false, sitPayAmount: "", kwPay: "", redline: "", override: "", repCloserCommissionTier: "", repWithSetterCommissionTier: "", companyCommission: false, companyKW: "", referrals: [] };
  const location = useLocation();
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState(initialValues);
  const [pagination, setPagination] = useState({});
  const [roles, setRoles] = useState([]);
  const [locationList, setLocationList] = useState([]);


  // filters sorting
  const [isFilter, setIsFilter] = useState(false);
  const [isSortLoading, setIsSortLoading] = useState(true);
  const [searchFilter, setSearchFilter] = useState('');
  const [activeFilter, setActiveFilter] = useState('');
  const [sortBy, setSortBy] = useState({ name: '', dir: -1 });


  // booleans
  const [cards, setCards] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDrawer, setIsdrawerOpen] = useState(false);


  const setParams = (name, value, resetParams = false) => {
    let searchParams;
    if (location.search && !resetParams) {
      const params = getParams();
      searchParams = new URLSearchParams(params)
    } else {
      let p = getParams();
      if (resetParams) {
        delete p?.sort
        delete p?.location
        delete p?.role
        searchParams = new URLSearchParams(p);
      } else {
        searchParams = new URLSearchParams()
      }
    }
    if (resetParams) {
      userRef.current.resetRoleAndLocation();
      resetFilters();
    }
    searchParams.set('offset', 0);
    searchParams.set('limit', 10);
    searchParams.set(name, value);
    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    })
  }
  const getParams = () => {
    const newParams = {};
    const urlParams = new URLSearchParams(window.location.search);
    const entries = Object.fromEntries(urlParams);
    if (entries.sort) {
      let s = entries.sort.split(',');
      entries.sort = { [s[0]]: s[1] };
    }
    if (entries.location) {
      entries.location = entries.location.split(',');
    }
    if (entries.role) {
      entries.role = entries.role.split(',');
    }
    for (let k in entries) {
      if (entries[k]) {
        newParams[k] = entries[k];
      }
    }
    return entries;
  }
  const resetFilters = () => {
    setIsSortLoading(true);
  }
  const handleChangeFilter = (e, name) => {
    setIsFilter(true);
    if (name === 'q') {
      setSearchFilter(e.target.value);
      setParams(name, e.target.value, true);
    }
    if (name === 'active') {
      setActiveFilter(e);
      setParams(name, e);
    }
    if (name === 'location') {
      setParams(name, e);
    }
    if (name === 'role') {
      setParams(name, e);
    }
    setIsSortLoading(true);
    getUser();
  };
  const updateFiltersFromParams = () => {
    let params = getParams();
    if (params.active) {
      setActiveFilter(params.active === 'true');
      userRef.current.setActive(params.active === 'true');
    }
    if (params.location) {
      userRef.current.setLocationFilter(params.location);
    }
    if (params.role) {
      userRef.current.setRoleFilter(params.role);
    }
  }
  const updatePagination = (current, pageSize) => {
    console.log("working");
    if (!cards) {
      setIsSortLoading(true);
    }
    let searchParams = new URLSearchParams(window.location.search);
    if (!pageSize) {
      searchParams.set('offset', current)
    } else {
      searchParams.set('offset', current)
      searchParams.set('limit', pageSize)
    }
    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    })
    getUser();
  }
  const sortHandleChange = (name, dir) => {
    setIsSortLoading(true);
    let searchParams = new URLSearchParams(location.search);
    searchParams.set('sort', [name, dir]);
    setSortBy({ name, dir});
    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    })
    setIsOpen(false);
    getUser()
  }


  // API's
  const getUser = () => {
    setIsLoading(true);
    const params = getParams();
    callPostApi("/user/query/users", params, (data) => {
      setUsers(data.data);
      setPagination(data.page);
      setIsLoading(false);
    }, () => { });
  }
  const handleLoginAsUser = (email, password) => {
    callPostApi("/auth/login/user/new/session", { email, password }, (data) => {
      SuccessNotification("Login Successful");
      saveStorage(data);
      history.push("/");
    }, (err) => {
      console.log(err);
    });
  };
  const handleSubmit = () => {
    setFormData({ ...formData, calId: formData.email });
    callPostApi("/user", formData, (data) => {
      getUser();
      SuccessNotification("User Added");
      setIsOpen(false);
      setFormData(initialValues);
      ref.current.resetFeilds();
      callPostApi(`/user/${data._id}`, () => { }, () => { })
    }, (err) => { console.log(err) });
  };

  const getRoles = () => {
    callGetApi("/roles", (data) => {
      setRoles(data);
    }, (err) => {
      console.log(err);
    })
  }

  const getLocations = () => {
    callGetApi("/location", (data) => {
      setLocationList(data);
    }, (err) => {
      console.log(err);
    })
  }

  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth < 900) {
        setCards(true);
      } else {
        setIsdrawerOpen(false);
        return setCards(false);
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  useEffect(() => {
    updateFiltersFromParams();
    getRoles();
    getLocations();
    getUser();

  }, [])

  return (
    <Wrapper isSmall={cards}>

      <Row gutter={[15, 15]} className="top-bar-row">
        <Col xs={24} sm={cards ? 24 : 22} lg={22} xl={22} xxl={22}>
          <div className="search-container">
            <Input placeholder="Search..." value={searchFilter} onChange={(e) => handleChangeFilter(e, 'q')} className="search-box" />
            <FaSearch size={cards ? 18 : 20} className="icon" />
          </div>
        </Col>
        {getUserPermissions("add-user-action") && (
          <>
            {cards ? (
              <Col xs={24} sm={24} lg={4} xl={4} xxl={4}>
                <div className="sm-add-users-container">
                  <div className="sm-add-users-title">Add Users</div>
                  <div className="sm-add-users-hr"></div>
                  <img src={AddCustomer} alt="add customer" className="sm-add-users-button" onClick={() => setIsOpen(true)} />
                </div>
              </Col>
            ) : (
              <Col xs={24} sm={cards ? 24 : 2} lg={2} xl={2} xxl={2}>
                <div className="add-desktop-button">
                  <FaUserPlus size={40} onClick={() => { history.push(setIsOpen(true)); }} cursor="pointer" />
                </div>
              </Col>
            )}
          </>
        )}
      </Row>


      {cards ? (isLoading && isSortLoading ? (
        <Loading />
      ) : (
        <div>
          {!users.length && isSortLoading ? (<div style={UserCustomStyles.emptyStyle}> <Empty /> </div>) : (
            <UserCard
              data={users}
              handleLoginAsUser={handleLoginAsUser}
              setIsdrawerOpen={setIsdrawerOpen}
              setIsLoading={isLoading}
              setIsSortLoading={setIsSortLoading}
              updatePagination={updatePagination}
              pagination={pagination}
            />
          )}
        </div>
      )) : (
        <UsersTable
          ref={userRef}
          data={users}
          isLoading={isLoading}
          handleLoginAsUser={handleLoginAsUser}
          updatePagination={updatePagination}
          pagination={pagination}
          sortHandleChange={sortHandleChange}
          getUser={getUser}
          roles={roles}
          handleChangeFilter={handleChangeFilter}
          location={locationList}
          sortBy={sortBy}

        />
      )}


      <Modal
        isOpen={isOpen}
        toggleModal={() => setIsOpen(false)}
        title="New User"
        className="user-Modal"
        footer={[
          <Row>
            <Col span={24}>
              <Button title="Submit" onClick={handleSubmit} />
            </Col>
          </Row>,
        ]}
      >
        <AddNewUser ref={ref} formData={formData} setFormData={setFormData} handleSubmit={handleSubmit} />
      </Modal>

      <Drawer
        title="Sort Users By."
        placement="bottom"
        className="users-drawer"
        onClose={() => {
          setIsdrawerOpen(false);
        }}
        visible={isOpenDrawer}
      >
        <div style={{ padding: "15px" }}>
          <Row>
            <Col span={24}>
              <Row>
                <Col span={24}>
                  <p
                    className="label"
                    onClick={() => sortHandleChange('username', sortBy.name === 'username' ? sortBy.dir === 1 ? -1 : 1 : 1)}
                    style={{
                      fontWeight: sortBy.name == "username" ? "bold" : "normal",
                    }}
                  >
                    Name
                    {sortBy.name == "username" && (
                      <CheckOutlined
                        style={{
                          color: "green",
                          float: "right",
                        }}
                      />
                    )}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <p
                    className="label"
                    onClick={() => sortHandleChange('email', sortBy.name === 'email' ? sortBy.dir === 1 ? -1 : 1 : 1)}
                    style={{
                      fontWeight: sortBy.name == "email" ? "bold" : "normal",
                    }}
                  >
                    Email Address
                    {sortBy.name == "email" && (
                      <CheckOutlined
                        style={{
                          color: "green",
                          float: "right",
                        }}
                      />
                    )}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <p
                    className="label"
                    onClick={() => sortHandleChange('location', sortBy.name === 'location' ? sortBy.dir === 1 ? -1 : 1 : 1)}
                    style={{
                      fontWeight: sortBy.name == "location" ? "bold" : "normal",
                    }}
                  >
                    Address
                    {sortBy.name == "location" && (
                      <CheckOutlined
                        style={{
                          color: "green",
                          float: "right",
                        }}
                      />
                    )}
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Drawer>
    </Wrapper >
  );
};

export default Users;
